import { Component, ElementRef, Input, AfterViewInit } from "@angular/core";
import { IVideoTestimonialsItemVm } from "../../video-testimonials-panel.component";

@Component({
  selector: "app-video-testimonials-reference",
  templateUrl: "./video-testimonials-reference.component.html",
  styleUrls: ["./video-testimonials-reference.component.less"],
})
export class VideoTestimonialsReferenceComponent implements AfterViewInit {
  @Input() item: IVideoTestimonialsItemVm;
  @Input() loadMedia: boolean;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: IVideoTestimonialsItemVm) {
    if (d.textColor && d.textColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--video-testi-panel-item-text-color",
        d.textColor.value
      );
    }
  }
}
